// @todo: Migrate to 'Dialog.Alert' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Alert} from '@wandb/weave/components/Alert';
import {ModelDetails} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/inference/ModelDetails';
import {useInferenceContext} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/inference/util';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React, {useEffect} from 'react';
import {useParams} from 'react-router';

import {setDocumentTitle} from '../util/document';
import {InferenceProvider} from './InferenceContext';

type InferenceModelParams = {
  collectionId?: string;
  modelId?: string;
};

const styleContainer = {width: '100%'};

const InferenceModelPage = () => {
  return (
    <InferenceProvider>
      <Tailwind style={styleContainer}>
        <InferenceModelPageInner />
      </Tailwind>
    </InferenceProvider>
  );
};

const InferenceModelPageInner = () => {
  const {collectionId, modelId} = useParams<InferenceModelParams>();
  const scopedId = `${collectionId}/${modelId}`;
  const context = useInferenceContext();

  const pageTitle = `Model Details - ${scopedId}`;
  useEffect(() => {
    setDocumentTitle(pageTitle);
  }, [pageTitle]);

  if (!modelId) {
    return null;
  }

  if (!context.isCatalogEnabled) {
    return (
      <div className="m-24">
        <Alert severity="info">{context.availabilityMessage}</Alert>
      </div>
    );
  }

  return <ModelDetails id={modelId} inferenceContext={context} />;
};

export default InferenceModelPage;
